import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Tooltip
} from "@chakra-ui/react"
import { ReactNode } from "react"

const PathwrightChakraTooltip = ({
  children,
  label
}: {
  children: ReactNode
  label: ReactNode
}) => {
  return (
    <Popover trigger="hover" openDelay={200}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent
        bg="black"
        color="white"
        borderColor="black"
        borderRadius="10px"
        p={3}
      >
        <PopoverArrow bg="black" />
        <PopoverBody>{label}</PopoverBody>
      </PopoverContent>
    </Popover>
  )

  return (
    <Tooltip
      hasArrow
      color="white"
      openDelay={200}
      sx={{
        "&": {
          padding: "var(--chakra-space-3) var(--chakra-space-4)"
        },
        "&, .chakra-tooltip__arrow": {
          backgroundColor: "#000 !important",
          opacity: "0.9"
        },
        p: {
          color: "whitesmoke"
        }
      }}
      borderRadius="md"
      label={label}
    >
      {children}
    </Tooltip>
  )
}

export default PathwrightChakraTooltip
